import { Store } from 'lucide-react';

interface ApprovalPendingMessageProps {
  blocked?: boolean;
}

export default function ApprovalPendingMessage({ blocked = false }: ApprovalPendingMessageProps) {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-md w-full text-center">
        <Store className="mx-auto h-12 w-12 text-primary mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          {blocked ? 'Conta Bloqueada' : 'Aguardando Aprovação'}
        </h2>
        <p className="text-gray-600 mb-4">
          {blocked 
            ? 'A sua conta está bloqueada. Por favor, entre em contacto com o suporte para mais informações.'
            : 'A sua conta ainda está aguardando aprovação ou sendo monitorizada por segurança. Terá de aguardar o nosso contacto.'}
        </p>
        <p className="text-sm text-gray-500">
          Para mais informações, contacte o suporte através do email: ola@lognow.pt
        </p>
      </div>
    </div>
  );
}